// #region Imports

import { ApiServiceBase } from './apiServiceBase';

// #endregion Imports

export class BookmarkService extends ApiServiceBase {
    private apiUrl = '/api/bookmarks/1.0';

    getBookmarks(onSuccess: (response: any) => void, onFailure: (response: any) => void) {
        this.get(this.apiUrl, onSuccess, onFailure);
    }

    deleteBookmarkById(bookmarkId, onSuccess: (response: any) => void, onFailure: (response: any) => void) {
        this.delete(`${this.apiUrl}/${bookmarkId}`, onSuccess, onFailure);
    }

    deleteBookmarkForPage(contentId, onSuccess: (response: any) => void, onFailure: (response: any) => void) {
        this.setForcedReload();
        this.delete(`${this.apiUrl}/page/${contentId}`, onSuccess, onFailure);
    }

    createBookmarkForPage(contentId, onSuccess: (response: any) => void, onFailure: (response: any) => void) {
        this.setForcedReload();
        this.post(this.apiUrl, onSuccess, onFailure, `=${contentId}`);
    }

    editBookmark(bookmark, onSuccess: (response: any) => void, onFailure: (response: any) => void) {
        const requestHeaders = {
            'Content-Type': 'application/json'
        };
        const requestBody = JSON.stringify(bookmark);
        fetch(`${this.apiUrl}/updatebookmark`, {
            method: 'POST',
            headers: requestHeaders,
            body: requestBody
        })
        .then(response => {
            if (response.ok) {
                return response.json();
            } else {
                throw new Error('Network response was not ok.');
            }
        })
        .then(data => onSuccess(data))
        .catch(error => onFailure(error));
    }

    userAccessedBookmark(onSuccess: (response: any) => void, onFailure: (response: any) => void) {
        this.post(`${this.apiUrl}/accessbookmark`, onSuccess, onFailure);
    }

    setForcedReload(): void {
        if (typeof ((window as any).unloadBookmarks) !== 'undefined') {
            (window as any).unloadBookmarks();
        }
    }

    getSelectedBookmarks(onSuccess: (response: any) => void, onFailure: (response: any) => void): JQuery.jqXHR {
        return this.get(`${this.apiUrl}/selected`, onSuccess, onFailure);
    }

    togglePinnedBookmark(bookmarkId, isPinned, onSuccess: (response: any) => void, onFailure: (response: any) => void) {
        this.put(`${this.apiUrl}/selected/${bookmarkId}/${isPinned}`, onSuccess, onFailure,);
    }

    selectPinnedBookmark(bookmarkId, onSuccess: (response: any) => void, onFailure: (response: any) => void) {
        this.put(`${this.apiUrl}/select/${bookmarkId}`, onSuccess, onFailure,);
    }

    unSelectPinnedBookmark(bookmarkId, onSuccess: (response: any) => void, onFailure: (response: any) => void) {
        this.put(`${this.apiUrl}/unselect/${bookmarkId}`, onSuccess, onFailure,);
    }

    updateSortOrder(
        bookmarkIds: string[],
        onSuccess: (response: any) => void,
        onFailure: (response: any) => void
    ) {
        const formData = new FormData();
        bookmarkIds.forEach((id) => formData.append("referenceIds", id));

        fetch(`${this.apiUrl}/updatesortorder`, {
            method: "PUT",
            body: formData,
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Failed to update sort order!!");
                }
                return response.json();
            })
            .then(onSuccess)
            .catch(onFailure);
    }
}